var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg08SupremeAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 842 567",
    width: 842,
    height: 567,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08_Supreme-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 518.8,
    y1: 304,
    x2: 345,
    y2: 292.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 427.5,
    y1: 347.8,
    x2: 336.4,
    y2: 341.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 323.6,
    y1: 263.6,
    x2: 497.5,
    y2: 275.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 415,
    y1: 219.8,
    x2: 506.1,
    y2: 226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c4ff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t\t.s3 { fill: url(#g4) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphics"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m496.1 161.9c0.5 18.4-7.2 30.3-22.9 39.5-19.2 11.2-39 22.8-58.3 33.9-21.5 12.4-26.8 27.4-11.4 47.3-5 11-22.4 8.9-32.1 7.3-10.7-6.5-13.9-20.8-13.3-32.5 0.9-16.7 9.7-32.5 21.8-43.8q58-43.7 116.1-87.2 0 17.7 0.1 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m403.5 282.6c0 0-2.4-1.9-6.2-5.3-18.3-16.3-42.1-41.5-17.4-63.7-8.1 6.2-14.9 13.6-20.8 21.5-17.5 23.4-14.1 61.1-13.3 89.3 0.4 13.5 16.4 16.5 26.6 11.1 11.2-6 23.1-12.6 33.9-18.5 16.6-8.9 8.5-25.3-2.8-34.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m346.4 405.8c-0.5-18.5 7.2-30.4 22.9-39.6 19.2-11.2 39-22.8 58.3-33.9 21.5-12.3 26.8-27.4 11.4-47.3 5-10.9 22.4-8.9 32.1-7.3 10.7 6.5 13.9 20.8 13.3 32.5-0.9 16.7-9.7 32.5-21.8 43.8q-58 43.7-116.1 87.2 0-17.7-0.1-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m439 285c0 0 2.3 1.9 6.2 5.3 18.3 16.3 42.1 41.5 17.4 63.7 8.1-6.2 14.9-13.6 20.8-21.5 17.5-23.4 14.1-61.1 13.3-89.3-0.4-13.5-16.4-16.5-26.6-11.1-11.2 6-23.1 12.6-33.9 18.5-16.6 8.9-8.5 25.3 2.8 34.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08SupremeAi);
export default __webpack_public_path__ + "static/media/08_Supreme-ai.aeaa289ddf099dffb4ee389f3624fe9b.svg";
export { ForwardRef as ReactComponent };